import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Router} from '@reach/router';
import firebase from 'firebase/app';
import 'firebase/auth';
import ReactAudioPlayer from 'react-audio-player';
import {createGlobalStyle} from 'styled-components';
import Main from './screen/Main';
import Track from './screen/Track';
import Home from './components/Home';
import Footer from './components/Footer';
import FooterPlayer from './components/FooterPlayer';
import SignIn from './screen/SignIn';
import {subscribeToUserProfile, fetchUser} from './store/actions';

const {
  REACT_APP_apiKey,
  REACT_APP_authDomain,
  REACT_APP_databaseURL,
  REACT_APP_messagingSenderId,
  REACT_APP_projectId,
  REACT_APP_storageBucket
} = process.env;

const firebaseConfig = {
  apiKey: REACT_APP_apiKey,
  authDomain: REACT_APP_authDomain,
  databaseURL: REACT_APP_databaseURL,
  projectId: REACT_APP_projectId,
  storageBucket: REACT_APP_storageBucket,
  messagingSenderId: REACT_APP_messagingSenderId
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const GlobalStyle = createGlobalStyle `

body {
  background-color: black;
  color: white;
  max-width: 100%;
  overflow-x: hidden auto;
}
html,body {
  max-width: 100%;
  overflow-x: hidden auto;
}

a {
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`;
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      playing: false,
      checkingAuth: true
    };
    // Create the ref
    this.rap = React.createRef();
  }

  componentDidMount() {
    const {music} = this.props;
    if (!music.audioPlayerState.domRef) {
      const trackInfo = {
        domRef: this.audioPlayerDomEl
      };
      this.props.player.updateAudio(trackInfo);
    }

    /**
     * IMPORTANT
     * This needs to use the === condition when developing locally
     * Set to !== when in production
     */
    // if (process.env.NODE_ENV === 'development') {
      firebase
        .auth()
        .onAuthStateChanged(user => {
          this.setState({checkingAuth: false});
          console.log('App->componentDidMount->firebase->auth', user);
          if (user) {
            this.props.fetchUser(user);
          }
        });
    // }
  }

  componentDidUpdate(prevProps) {
    const {gotUserProfileFromFirestore, isLoggedIn} = this.props.auth;
    if (isLoggedIn && !gotUserProfileFromFirestore) {
      this.props.subscribeToUserProfile();
    }
  }

  audioPlayerDomEl = () => this.rap.audioEl;

  _playPauseAudioSwitch = () => {
    this.setState(prevState => ({
      playing: !prevState.playing
    }));
    const a = this.rap.audioEl;
    if (a.paused) {
      a.play();
      this.setState({playPauseIcon: 'fas fa-pause', PlayIconLeft: '1'});
    } else {
      a.pause();
      this.setState({playPauseIcon: 'far fa-play', PlayIconLeft: '1.75rem'});
    }
  };

  _pauseAudio = () => {
    const a = this.rap.audioEl;
    a.pause();
  };

  _playAudio = () => {
    const a = this.rap.audioEl;
    a.play();
  };

  _increaseSongProgress = () => {
    // this.setState(prevState => ({ songProgress: prevState.songProgress + 1 }));
    const {music} = this.props;
    const trackInfo = {
      songProgress: music.audioPlayerState.songProgress + 1
    };
    this
      .player
      .updateAudio(trackInfo);
  };

  render() {
    /*
    audioPlayerState: {
    trackID: '',
    isPlaying: false,
    playPause: '',
    showFooterPlayer: false,
    songSrc: '',
    songProgress: 0,
    stopPlaying: false,
  },
    */
    const {songSrc} = this.props.music.audioPlayerState;
    //onListen = { this._increaseSongProgress }
    return (
      <React.Fragment>
        <ReactAudioPlayer
          listenInterval={300}
          src={songSrc}
          ref={element => this.rap = element}/>
        <Router>
          <Main path="/" checkingAuth={this.state.checkingAuth} player={this.props.player}/>
          <Track player={this.props.player} path="/track"/>
          <Track player={this.props.player} path="/track/:search"/>
          <Home path="/home"/>
          <SignIn path="/verify"/>
        </Router>
        <GlobalStyle/>
        <Footer/> {this.props.music.audioPlayerState.showFooterPlayer && <FooterPlayer player={this.props.player}/>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({auth: state.auth, music: state.music});

const mapDispatchToProps = dispatch => {
  return {
    subscribeToUserProfile: () => dispatch(subscribeToUserProfile()),
    fetchUser: (user) => dispatch(fetchUser(user)),
    dispatch: func => dispatch(func)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js